import BottomSection from "../components/BottomSection";
import ContactUs from "../components/ContactUs";
import Header from "../components/Header";

export default function ContactUsPage() {
  return (
    <div>
      <Header />
      <div style={{ minHeight: "70vh" }}>
        <ContactUs />
      </div>
      <BottomSection />
    </div>
  );
}
